import { useFlags } from 'launchdarkly-react-client-sdk'

type FlagConfig = Record<string, { type: string }>
type ExtractFlags<T extends FlagConfig> = Record<keyof T, boolean>

/**
 * Creates a typed LaunchDarkly feature flags hook from a flags.json config.
 *
 * @example
 * export const useMyFlags = createFlagsHook<typeof import('./flags.json')>()
 */
export const createFlagsHook = <TFlagConfig extends FlagConfig>() => useFlags as () => ExtractFlags<TFlagConfig>
